import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="container">
          <div className="cart-page__empty">
            <h1>Your cart is empty</h1>
            <Link to="/shop" onClick={toTop} className="cart-page__continue-shopping">
              Continue shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="container">
        <div className="cart-page__header">
          <h1>Your cart</h1>
          <Link to="/shop" onClick={toTop} className="cart-page__continue-shopping">
            Continue shopping
          </Link>
        </div>

        <div className="cart-page__content">
          <div className="cart-page__items">
            <div className="cart-page__table-header">
              <span className="cart-page__product-label">Product</span>
              <span className="cart-page__quantity-label">Quantity</span>
              <span className="cart-page__total-label">Total</span>
            </div>

            {cartItems.map((item, idx) => {
              const product = getProductById(item.id);
              if (!product) return null;
              
              const itemTotal = (parseFloat(product.price.replace(/,/g, "")) * item.quantity).toFixed(2);
              
              return (
                <div key={idx} className="cart-page__item">
                  <div className="cart-page__item-product">
                    <div className="cart-page__item-image">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                        <img
                          src={`/generated/cart/${product.id}.jpg`}
                          alt={product.name}
                        />
                      </Link>
                    </div>
                    <div className="cart-page__item-details">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop} className="cart-page__item-name">
                        {product.name}
                      </Link>
                      <div className="cart-page__item-price">
                        ${product.price}
                      </div>
                      {item.size && item.size !== "One size" && (
                        <div className="cart-page__item-variant">
                          Size: {item.size}
                        </div>
                      )}
                      {item.color && item.color !== "Default" && (
                        <div className="cart-page__item-variant">
                          Color: {item.color}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="cart-page__item-quantity">
                    <button
                      className="cart-page__quantity-btn"
                      onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                    >
                      −
                    </button>
                    <span className="cart-page__quantity-value">{item.quantity}</span>
                    <button
                      className="cart-page__quantity-btn"
                      onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                    >
                      +
                    </button>
                    <button
                      className="cart-page__remove-btn"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      🗑
                    </button>
                  </div>

                  <div className="cart-page__item-total">
                    ${itemTotal}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-page__summary">
            <div className="cart-page__subtotal">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)} USD</span>
            </div>
            
            <div className="cart-page__tax">
              Tax included and shipping calculated at checkout
            </div>

            <button
              className="cart-page__checkout-btn"
              onClick={handleCheckout}
            >
              Check out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
